import React from 'react';
import { Section } from '../../components/Section';
import { SectionTitle, CTASectionSubtitle } from '../Typography';
import { AnchorButton, Button } from '../Button';
import colors from 'src/style/colors';
import { CTAContainer, CTABtnWrapper, CTAInfoContent } from './elements';
import { RocketIllustration } from './index';
import { StarsCTAFooter } from '../Illustrations';
import { mediaQueries } from 'src/style/breakpoints';
import ModalForm from '../Modal/ModalFormSyllabus';
import { useMediaQueries } from 'src/utils/MediaQueries';
import ButtonScrollToForm from '../LandingPage/ButtonScrollToForm';

/**
 * @type React.FunctionComponent<{ numberOfWeeks: string, format: string}>
 */

const CTASection = React.memo(
  ({
    onBoardingPromise,
    course,
    numberOfWeeks,
    nextSession,
    format,
    nextPartTimeSession,
    nextFullTimeSession,
    fromFormationsPageCertification,
    fromFormationsPageType,
    formSuccess,
    setFormSuccess,
    values,
    setValues,
    landing,
  }) => {
    const [isModalFormOpen, setIsModalFormOpen] = React.useState(false);
    const mqs = useMediaQueries();

    return (
      <Section theme="primary">
        <CTAContainer>
          <RocketIllustration />
          <StarsCTAFooter />
          <CTAInfoContent data-cy="CTAinfoContent">
            <SectionTitle
              isCenter
              css={{
                paddingTop: 16,
                [mediaQueries.phoneOnly]: {
                  fontSize: 25,
                },
              }}
            >
              Prêt à embarquer pour
              <br />
              {onBoardingPromise} ?
            </SectionTitle>
            <div
              css={{
                padding: landing ? '54px 0 0 0' : '54px 0',
              }}
            >
              <CTASectionSubtitle>
                {mqs.tabletLandscapeUp || mqs.phoneOnly ? (
                  <>
                    Formation {course}, {format}
                  </>
                ) : (
                  <>
                    Formation {course},<br></br>
                    {format}
                  </>
                )}
                {/* Formation {course}, {format} */}
                <br />
                <div
                  css={{
                    color: colors.yellow,
                    [mediaQueries.phoneOnly]: {
                      paddingTop: 20,
                    },
                  }}
                >
                  Prochaine session :{' '}
                  <br
                    css={{
                      [mediaQueries.tabletPortraitUp]: {
                        display: 'none',
                      },
                    }}
                  />
                  {nextSession}
                </div>
              </CTASectionSubtitle>
            </div>
            {landing ? (
              <ButtonScrollToForm text={`Je postule\u00A0!`} />
            ) : (
              <CTABtnWrapper>
                <AnchorButton
                  className="apply-btn"
                  to="/postuler"
                  state={{
                    fromFormationsPage: {
                      certification: fromFormationsPageCertification,
                      type: fromFormationsPageType,
                      date: nextPartTimeSession ? nextPartTimeSession : nextFullTimeSession,
                    },
                  }}
                >
                  Postuler
                </AnchorButton>
                {landing ? null : (
                  <>
                    <div
                      css={{
                        width: '16px',
                        [mediaQueries.phoneOnly]: {
                          marginBottom: '16px',
                        },
                      }}
                    />
                    <Button
                      secondary
                      onClick={() => {
                        setIsModalFormOpen(!isModalFormOpen);
                      }}
                    >
                      Recevoir notre programme
                    </Button>
                    {isModalFormOpen && (
                      <>
                        <ModalForm
                          isOpen={isModalFormOpen}
                          onClose={() => {
                            setFormSuccess(false);
                            setIsModalFormOpen(false);
                          }}
                          fromFormationsPageType={fromFormationsPageType}
                          formSuccess={formSuccess}
                          setFormSuccess={setFormSuccess}
                          values={values}
                          setValues={setValues}
                        />
                      </>
                    )}
                  </>
                )}
              </CTABtnWrapper>
            )}
          </CTAInfoContent>
        </CTAContainer>
      </Section>
    );
  }
);
export default CTASection;
